import { render, staticRenderFns } from "./add-client.vue?vue&type=template&id=7268887c&scoped=true&"
import script from "./add-client.vue?vue&type=script&lang=js&"
export * from "./add-client.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7268887c",
  null
  
)

export default component.exports